import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        root: {
            overflow: 'hidden',
            width: '500px'
        },
        container: {
            padding: '20px',
            minHeight: '450px',
            paddingBottom: '0px',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '20px'
        },
        editBackground: {
            position: 'absolute',
            top: '-30px',
            right: '-30px',
            background: colors.color1,
            color: colors.color5,
            borderRadius: '50%',
            width: '80px',
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& .MuiSvgIcon-root': {
                transform: 'translate(-10px, 8px)'
            },
            '&:hover': {
                background: `${colors.color1}dd`,
            }
        },
        title: {
            color: colors.color1,
            fontSize: '18px',
            fontWeight: 'bold',
        },
        body: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
            height: 'fit-content'
        },
        form: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px'
        },
        footer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'end',
            '& .MuiButton-root': {
                fontSize: '14px',
                '&.red': {
                    color: colors.color12
                },
                '&.blue': {
                    color: colors.color1
                },
                '&.Mui-disabled': {
                    color: colors.color32
                }
            }
        }
    }
}

export { useStyles }
